// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyDj-FJ1CTXulSLhHLCeN2cfNP8TUlfDKHE",
    authDomain: "elettroservizi-e243b.firebaseapp.com",
    projectId: "elettroservizi-e243b",
    storageBucket: "elettroservizi-e243b.firebasestorage.app",
    messagingSenderId: "13891219146",
    appId: "1:13891219146:web:9cc525d9cd1b297bbf0e33",
    measurementId: "G-D7M1QGPJQF"
};

// Initialize Fireba
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);
